import { render, staticRenderFns } from "./PureAlert.vue?vue&type=template&id=2a4af01a&scoped=true&"
import script from "./PureAlert.vue?vue&type=script&lang=js&"
export * from "./PureAlert.vue?vue&type=script&lang=js&"
import style0 from "./PureAlert.vue?vue&type=style&index=0&id=2a4af01a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4af01a",
  null
  
)

export default component.exports